type VideoSliderItemProps = {
  title: string
  subtext: string
  link?: string
  videoId: string
}

export const videoSliderData: VideoSliderItemProps[] = [
  {
    title: 'Analyze drivers & drags',
    subtext: 'Identify what’s impacting key metrics.',
    videoId: 'ho0fq7c5jc',
  },
  {
    title: 'Get insights delivered',
    subtext: 'Send updates right to your inbox.',
    videoId: 'h1fmozdcjc',
  },
  {
    title: 'Diagnose changes',
    subtext: 'Understand what happened and why.',
    videoId: 'hhjgmlv1dl',
  },
  {
    title: 'Look up data quickly',
    subtext: 'Get answers in seconds.',
    videoId: '8zlnz0wxk9',
  },
]
